import React from 'react'
import cx from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import { Form as ReactFinalForm, Field } from 'react-final-form'
import { Text, Boutton as Button } from '@piconetworks/ui'
import Form from '@piconetworks/pkg-form'

import ActionModal from 'components/ActionModal'
import ModalModule from 'modules/modal'
import IntegrationsModule from 'modules/integrations'

import styles from './UninstallConfirm.module.scss'

const UninstallConfirmation = ({
    actionKey = '',
    appName = '',
    closeOnSuccess = '',
    espType = '',
    id = '',
    name = '',
}) => {
    const dispatch = useDispatch()

    return (
        <ReactFinalForm
            onSubmit={({ cancelRecurringPayments }) => {
                dispatch(IntegrationsModule.creators.uninstallIntegration({ id, cancelRecurringPayments, type: espType, appName }))
                dispatch(ModalModule.creators.closeModal({ key: actionKey }))
                if (closeOnSuccess) {
                    dispatch(ModalModule.creators.closeModal({ key: closeOnSuccess }))
                }
            }}
            render={({ handleSubmit, values, submitting }) => {
                const hasPurchases = useSelector(IntegrationsModule.selectors.getMonetizationHasPurchases)
                const isStripe = espType === 'stripe'

                return (
                    <ActionModal.Wrapper type="danger" actionKey={actionKey}>
                        <form onSubmit={handleSubmit}>
                            <ActionModal.Header small header={ isStripe ? 'Uninstall Stripe?' : `Uninstall ${name}?`} />
                            <ActionModal.Body>
                                {(isStripe) ? (
                                    <div>
                                        <Text.P>
                                            <Text.Span className={styles.bold}>Proceed with caution.&nbsp;</Text.Span>
                                            Uninstalling Stripe will remove any products you have created in Hype,
                                            and your customers may lose access to benefits currently managed by Hype.

                                        </Text.P>
                                        {hasPurchases && (
                                            <div>
                                                <Text.P>
                                                    Carefully review the options below and select how you wish to uninstall Stripe:
                                                </Text.P>
                                                <div className={styles.recurringPaymentsRadios}>
                                                    <Field
                                                        type='radio'
                                                        name='cancelRecurringPayments'
                                                        component={Form.Radio}
                                                        text='Cancel all recurring payments.'
                                                        value='true'
                                                        initialValue='true'
                                                    />
                                                    <Text.Span>
                                                        There will be no further revenue from any products you are currently using Hype to manage.
                                                    </Text.Span>
                                                    <Field
                                                        type='radio'
                                                        name='cancelRecurringPayments'
                                                        component={Form.Radio}
                                                        text='Do NOT cancel recurring payments.'
                                                        value='false'
                                                    />
                                                    <Text.Span>
                                                        Hype will no longer collect any fees from any payments processed through your Stripe account.
                                                        However, users currently making recurring payments through Hype will no longer be able to update their accounts through Hype. Once this action is complete,
                                                        Hype will be unable to modify or cancel these recurring payments in the future.
                                                    </Text.Span>
                                                </div>
                                            </div>
                                        )}

                                        <Field
                                            autoFocus
                                            component={Form.Input}
                                            name="goodbye"
                                            type="text"
                                            label="Type &quot;UNINSTALL&quot; below to confirm your request. Once complete, this action cannot be undone."
                                        />
                                    </div>
                                ) : (
                                <>
                                    <Text.P>
                                        Do you want to uninstall {name}?
                                    </Text.P>
                                    <Field
                                        autoFocus
                                        component={Form.Input}
                                        name="goodbye"
                                        type="text"
                                        label="Type &quot;UNINSTALL&quot; to confirm"
                                    />
                                </>
                                )}

                            </ActionModal.Body>
                            <ActionModal.Footer
                                flexboxContainer={{
                                    justifyContent: 'end',
                                    alignItems: 'center'
                                }}
                                cancelButton={
                                    <Button
                                        className={cx(styles.cancel)}
                                        variant={'link'}
                                    >
                                        Cancel
                                    </Button>
                                }
                                actionButton={
                                    <Button
                                        disabled={values.goodbye !== 'UNINSTALL' || submitting}
                                        type="submit"
                                        className={cx(styles.action)}
                                        variant="danger"
                                    >
                                        Uninstall
                                    </Button>
                                }
                            />
                        </form>
                    </ActionModal.Wrapper>
                )
            }}
        />
    )
}

export default UninstallConfirmation
